const SECRET_KEY_PATTERNS = [
  /_access_token$/i,
  /_refresh_token$/i,
  /_access_secret$/i,
  /(^|_)(api|webhook|client)_secret$/i,
  /(^|_)token$/i,
];

const EXACT_SECRET_KEYS = new Set([
  "password",
  "resetPasswordToken",
  "confirmationToken",
  "trello_token",
  "upwork_token",
  "upwork_refresh_token",
  "upwork_access_token",
  "upwork_access_secret",
  "fortnox_access_token",
  "fortnox_refresh_token",
  "fortnox_state",
  "key_hash",
  "hashedKey",
  "client_secret",
]);

export const isSecretFieldName = (key: string) => {
  if (!key) return false;
  if (EXACT_SECRET_KEYS.has(key)) return true;
  return SECRET_KEY_PATTERNS.some((pattern) => pattern.test(key));
};

/**
 * Drop credential field names from user/org JSON stored in Redux / localStorage.
 * Does not touch billing details used on the owned-organization admin screen.
 */
export const omitSecretFields = (value: any): any => {
  if (value == null || typeof value !== "object") {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map(omitSecretFields);
  }

  const out: Record<string, unknown> = {};
  for (const [key, nested] of Object.entries(value)) {
    if (isSecretFieldName(key)) {
      continue;
    }
    out[key] = omitSecretFields(nested);
  }
  return out;
};
